export class TaxAuthority {
    tax_authority_id: string = null;
    tax_authority: string = null;
    rate: string = null;
    organization_id: string = null;
    name: string = null;
    created_by: string = null;
    description: string = null;
}
